<template>
  <div id="speakerssection" class="grey-background px-12">
    <!-- <v-container> -->
    <v-row class="text-left">
      <!-- <v-col cols="12">
        <v-img
          :src="require('../assets/logo.svg')"
          class="my-3"
          contain
          height="200"
        />
      </v-col>-->

      <v-col class="mb-2" cols="12">
        <div class="py-12"></div>
        <h3 class="mb-4 display-1">Discuti, sperimenta e impara insieme a loro. 
          <br> La TechSoup Together cresce con te.</h3>
        <p
          class="font-weight-light title"
        >Potrai interagire con una comunità di operatori del sociale, aiutare e chiedere consiglio. <br>
Perché non c’è niente di più potente che imparare da storie ed esperienze di chi opera sul campo come te.</p>
      </v-col>
    </v-row>

    <v-row class="align-center mb-12">
      <v-col class="col-md-3 col-12" v-for="(speaker, index) in loadedSpeakers" :key="index">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="mx-auto"
            :elevation="hover ? 6 : 3"
            @click="goToSpeaker(speaker)"
          >
            <v-img :src="`${speaker.downloadImgUrl}`" height="200px">
              <div class="d-flex justify-end pt-2 pr-2" v-if="speaker.areas_of_expertise">
                <v-chip color="primary" label x-small>{{speaker.areas_of_expertise[0]}}</v-chip>
              </div>
            </v-img>

            <v-card-title class>{{speaker.first_name}} {{speaker.last_name}}</v-card-title>

            <v-card-subtitle class="caption">
              <span class="primary--text">{{speaker.organization}}</span>
              <br />
              <span class="font-italic">{{speaker.role}}</span>
            </v-card-subtitle>
          </v-card>
        </v-hover>
      </v-col>

      <v-col class="col-md-3 col-12">
        <div class="pl-7">
          <p class="headline">E tanti altri</p>
          <v-btn class="primary" to="/speakers">Vedi tutti</v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- <v-row class="align-center mb-12">
      <v-col class="col-md-3 col-12" v-for="(speaker, index) in loadedSpeakers" :key="index">
        <v-hover v-slot:default="{ hover }">
          <v-card
            class="mx-auto theme--light"
            :elevation="hover ? 36 : 24"
            link
            @click="$router.push(`/speakers/${speaker.slug}`)"
          >
            <v-img
              class="white--text align-end"
              aspect-ratio="1"
              :src="`${speaker.downloadImgUrl}`"
              gradient="to right, rgba(5, 11, 31, .1), rgba(5, 11, 31, .1)"
            >
              <div class="pl-4" v-if="speaker.areas_of_expertise">
                <v-chip color="primary" x-small>{{speaker.areas_of_expertise[0]}}</v-chip>
              </div>
              <v-card-title
                class="headline"
                style="padding-top: 5px"
              >{{speaker.first_name}} {{speaker.last_name}}</v-card-title>
            </v-img>
          </v-card>
        </v-hover>
      </v-col>

      <v-col class="col-md-3 col-12">
        <div class="pl-7">
          <p class="headline">And many more</p>
          <v-btn class="primary" to="/speakers">See All</v-btn>
        </div>
      </v-col>
    </v-row>-->
    <div class="py-12"></div>
    <!-- </v-container> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      speakers: []
    };
  },
  computed: {
    loadedSpeakers() {
      return this.$store.getters.loadedSpeakers;
    }
  },
  methods: {
    goToSpeaker(speaker){
      this.$router.push(`/speakers/${speaker.slug}`)
      window.scrollTo(0,0);
    }
  }
};
</script>

<style>
.grey-background {
  background-color: #F4F4F4 !important;
}
</style>